import React from 'react';
import {
    Badge,
    Schedule as WaitIcon,
    AccountCircle as AccountIcon,
    Event as EventIcon,
    CheckCircle as DoneIcon,
    Cancel as LostIcon
} from '@mui/icons-material';

export const STATUS_CONFIG = {
    new: {
        label: 'New Lead',
        color: 'primary',
        icon: ({ overdue }) => (
            <Badge color={overdue ? "error" : "primary"} variant="dot">
                <WaitIcon fontSize="small" />
            </Badge>
        )
    },
    contacted: {
        label: 'Contacted',
        color: 'info',
        icon: () => <AccountIcon fontSize="small" />
    },
    'follow-up': {
        label: 'Follow Up',
        color: 'warning',
        icon: () => <EventIcon fontSize="small" />
    },
    won: {
        label: 'Won',
        color: 'success',
        icon: () => <DoneIcon fontSize="small" />
    },
    lost: {
        label: 'Lost',
        color: 'error',
        icon: () => <LostIcon fontSize="small" />
    },
};

export const CRM_TABS = [
    { value: 'new', label: 'New' },
    { value: 'contacted', label: 'Contacted' },
    { value: 'follow-up', label: 'Follow Up' },
    { value: 'won', label: 'Won' },
    { value: 'lost', label: 'Lost' }
];
